<template>
	<div class="policy">
		<!-- header -->
		<!-- <div class="policy.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="policy.block">
			<intellectual-navigation :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="policy.bread" data-aos="fade-left">
			<Bread :currentPage="{name:'政策解读',path:'/Policy'}" />
		</div>
		<div class="policy.container" v-loading="loading">
			<ul>
				<li v-for="(item,index) in policyData" :key="index" data-aos="fade-up">
					<a href="javascript:;" @click="goPolicyDetail(item.id)">
						<div class="policy.date">
							<span>{{item.date.substring(8,10)}}</span>
							<span>{{item.date.substring(0,7)}}</span>
						</div>
						<div class="policy.desc">
							<h4>{{item.title}}</h4>
							<p v-html="item.desc.replace(/<\/?(img|a)[^>]*>/gi, '')"></p>
						</div>
					</a>
				</li>

			</ul>
			<div class="policy.page" data-aos="fade-up" v-show=" this.totalMCount > this.pagePer">
				<el-pagination background layout="prev, pager, next" :hide-on-single-page="true" @size-change="handleMChange"
				 @current-change="handleMCurrentChange" :current-page.sync="pageMNo" :page-size="15" :total="totalMCount">
				</el-pagination>
			</div>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'


	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,


		},
		data() {
			return {
				totalMCount: 0,
				pageMNo: 1,
				isTrademark:false,
				lists: [],
				loading:false

			}
		},
		computed:{
			policyData(){
				 return this.lists.map(({ name, date_time, content, id}) => {
							return {
								title: name,
								date: date_time,
								desc: content,
								id: id ,
							}
						})
			}
		},
		methods:{
			toggleTrademarks(val){
				this.isTrademark = val
			},
			handleMChange(val) {
				this.$nextTick(() => {
					this.initPolicyData()
				})
			},
			handleMCurrentChange(val) {
				this.initPolicyData()
			},
			initPolicyData(){
				this.loading = true
				this.http.get(`IPR_Policy?page=${this.pageMNo}`).then(res => {
					if(res.code == 0 ){
						this.loading = false
						this.lists = res.data.data;
						this.totalMCount = res.data.total
					}
					
				})
			},
			goPolicyDetail(id){
				let routeUrl = this.$router.resolve({
					path: this.$route.path + '/' + id,
				});
				window.open(
				  location.pathname + "#" + routeUrl.resolved.fullPath,
				  "_blank"
				); //线上发布用
			}
			
		},
		mounted(){
			this.initPolicyData()
		}
	}
</script>

<style lang="scss">
	@include component(policy) {
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}

		@include part(bread) {
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}

		@include part(container) {
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			color: #999999;
			font-size: 16px;

			>ul {
				width: 1200px;
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				padding-top: 18px;
				padding-bottom: 18px;

				li {

					border: 1px solid transparent;
					padding: 46px;
					background: #FFFFFF;
					box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

					&:not(:nth-child(1)) {
						margin-top: 10px;
					}

					a {
						width: 100%;
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #999999;
					}

					&:hover {
						border-color: #F47227;
						h4{
							color: #F47227;
						}
					}
				}
			}

		}

		@include part(date) {
			width: 88px;
			height: 88px;
			background: rgba(247, 247, 247, 1);
			border-radius: 20px;
			display: flex;
			flex-direction: column;

			span {
				display: inline-block;

				&:nth-child(1) {
					font-size: 48px;
					font-weight: 400;
				}
			}
		}

		@include part(desc) {
			padding-left: 25px;
            width:calc(100% - 88px);
			h4 {
				margin: 0;
				text-align: left;
				font-size: 18px;
				//color: #F47227;
				color: #333;
				position: relative;

				&:before {
					display: inline-block;
					content: '';
					width: 60px;
					height: 2px;
					background: #F47227;
					position: absolute;
					bottom: -5px;
					left: 0;
				}
			}

			>p {
				text-align: left;
				margin-top: 19px;
				max-height:40px;
				overflow:hidden;
				>p{
					&:nth-child(n+3){
						display: none;
					}
				}
			}
		}

		@include part(page) {
			width: 1200px;
			margin: 0 auto;
			height: 80px;
			background: #fff;
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>
